<template>
    <div class="text-center border py-1">
          <button class="btn btn-outline-secondary ml-4" :disabled="activePage==1" @click="Prev"><i class="fas fa-angle-right mt-1"></i></button>
          <span> صفحه </span>
          <span> {{ activePage }} </span>
          <span> از </span>
          <span> {{ getallPage() }} </span>
          <span class="mr-2">( تعداد : {{ countAll }} ردیف)</span>
          <button class="btn btn-outline-secondary mr-4" :disabled="activePage==getallPage()" @click="Next"><i class="fas fa-angle-left mt-1"></i></button>
        </div>
</template>
<script>
export default {
    data() {
        return {
            pageNation:10
        }
    },
    props:['countAll','activePage'],
    methods:{
        getallPage(){
            return  Math.ceil(this.countAll /this.pageNation)
        },
        Next(){
            let num=JSON.parse(JSON.stringify(this.activePage))
            num=num+1
            this.$emit('newPage',num)
        },
        Prev(){
            let num=JSON.parse(JSON.stringify(this.activePage))
            num=num-1
            this.$emit('newPage',num)
        }
    }
}
</script>
<style scoped>

</style>